import React, {useState} from "react";
import EditUserModal from "./EditUserModal";
import DeleteUserModal from "./DeleteUserModal";
import useUsers from "../../../hooks/useUsers";
import CommonTable from "../../CommonTable/CommonTable";
import ActiveIcon from "../../Image/ActiveIcon";
import * as Roles from "../../AccountManagement/Users/Roles";
import InviteUserModal from "./InviteUserModal";
import ResetUserPasswordModal from "./ResetUserPasswordModal";
import {Toaster} from "react-hot-toast";

const AdminUsersPage = () => {
    const organizationId = 1;
    const {users, loading, reload} = useUsers({organizationId, justUser: true});
    const [selectedUser, setSelectedUser] = useState(null);
    const [modal, setModal] = useState(null);

    const closeModal = () => setModal(null);

    const columns = [
        {field: 'firstName', header: 'First Name'},
        {field: 'lastName', header: 'Last Name'},
        {field: 'email', header: 'Email'},
        {field: 'roleList', header: 'Type'},
        {
            field: 'isActive',
            header: 'Is Active',
            render: (row) => <ActiveIcon isActive={row.isActive}/>
        },
        {
            field: 'actions',
            header: 'Actions',
            sortable: false,
            render: (row) => (<div>
                <button type="button" className="secondary-btn btn-small" onClick={() => {
                    setSelectedUser(row);
                    setModal('delete')
                }}>Delete
                </button>
                <button type="button" className="primary-btn btn-small" onClick={() => {
                    setSelectedUser(row);
                    setModal('edit')
                }}>Edit
                </button>
                <button type="button" className="secondary-btn btn-small" onClick={() => {
                    setSelectedUser(row);
                    setModal('reset')
                }}>Reset Password
                </button>
            </div>)
        }
    ];

    return (
        <div>
            <div className="infoPage">
                <Toaster
                    position="bottom-center"
                    toastOptions={{
                        duration: 5000,
                        style: {
                            borderRadius: '10px',
                            background: '#333',
                            color: '#fff',
                        }
                    }}
                />
                <div className="row no-gutters">
                    <div className="col">
                        <h3 className="pageTitle" id="tableLabel">Active Users</h3>
                    </div>
                    <div className="col pageTitle">
                        <div className="btn-right">
                            <button
                                type="Add"
                                className="secondary-btn btn-large w-100"
                                onClick={() => {
                                    setSelectedUser(null);
                                    setModal('invite')
                                }}
                            >+ Invite User
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <CommonTable
                        data={users}
                        columns={columns}
                        itemsPerPage={10}
                        defaultSortField="firstName"
                        defaultSortDirection="asc"
                        loading={loading}
                    />
                    {modal === 'invite' && (
                        <InviteUserModal
                            onClose={closeModal}
                            onInvited={reload}
                            roles={Roles.roles}
                            organization={{id: organizationId, name: "Lifewhere"}}
                        />
                    )}
                    {modal === 'delete' && (
                        <DeleteUserModal
                            user={selectedUser}
                            onClose={closeModal}
                            onDeleted={reload}
                        />
                    )}
                    {modal === 'edit' && (
                        <EditUserModal
                            user={selectedUser}
                            onClose={closeModal}
                            onUpdated={reload}
                            roles={Roles.roles}
                        />
                    )}
                    {modal === 'reset' && (
                        <ResetUserPasswordModal
                            user={selectedUser}
                            onClose={closeModal}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default AdminUsersPage;